import { api } from '../api.js';
import { renderHeader, bindHeader } from '../components/header.js';
import { toast } from '../utils/toast.js';

const STATUS_META = {
  open:         { label: 'В работе',   cls: 'status-open' },
  waiting_user: { label: 'Ждём юзера', cls: 'status-waiting' },
  resolved:     { label: 'Закрыт',     cls: 'status-resolved' },
};

function fmtTime(d) { return d ? new Date(d).toLocaleString('ru', { dateStyle: 'short', timeStyle: 'short' }) : ''; }
function escapeHtml(s) { return String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

export async function renderAdminTicketsPage({ root }) {
  root.innerHTML = renderHeader({ active: 'admin-tickets' }) + `
    <div class="container admin-container">
      <h1 class="admin-title">Тикеты поддержки</h1>
      <div class="admin-toolbar">
        <div class="status-filter" id="status-filter">
          ${['open', 'waiting_user', 'resolved', 'all'].map((s) => `<button class="status-filter-btn" data-status="${s}">${s === 'all' ? 'Все' : (STATUS_META[s]?.label ?? s)}</button>`).join('')}
        </div>
        <div class="text-muted" id="tickets-count"></div>
      </div>
      <div id="tickets-table" class="admin-users-table">Загрузка…</div>
    </div>
  `;
  bindHeader();

  const filterEl = root.querySelector('#status-filter');
  const tableEl = root.querySelector('#tickets-table');
  const countEl = root.querySelector('#tickets-count');
  let status = 'open';

  filterEl.querySelectorAll('.status-filter-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      status = btn.dataset.status;
      filterEl.querySelectorAll('.status-filter-btn').forEach((b) => b.classList.toggle('active', b === btn));
      reload();
    });
  });
  filterEl.querySelector(`[data-status="${status}"]`)?.classList.add('active');

  async function reload() {
    tableEl.textContent = 'Загрузка…';
    try {
      const data = await api.adminSupport.list({ status, limit: 100 });
      countEl.textContent = `${data.total} тикетов`;
      tableEl.innerHTML = renderTable(data.tickets);
      tableEl.querySelectorAll('tr[data-id]').forEach((tr) => {
        tr.addEventListener('click', () => openDetail(tr.dataset.id));
      });
    } catch (err) {
      if (err.status === 403) tableEl.innerHTML = '<div class="text-muted">Нужны права администратора.</div>';
      else tableEl.textContent = 'Ошибка: ' + (err.message || '');
    }
  }

  function renderTable(tickets) {
    if (!tickets.length) return '<div class="text-muted">Пусто.</div>';
    return `
      <table>
        <thead>
          <tr><th>Юзер</th><th>Категория</th><th>Последнее</th><th>Обновлён</th><th>Статус</th></tr>
        </thead>
        <tbody>
          ${tickets.map((t) => {
            const meta = STATUS_META[t.status] ?? STATUS_META.open;
            const unread = t.unreadForAdmin ? '<span class="unread-dot" title="Новое от юзера"></span>' : '';
            return `
              <tr data-id="${t.id}" style="cursor:pointer;">
                <td class="cell-email">${unread}${escapeHtml(t.userEmail)}</td>
                <td>${escapeHtml(t.categoryLabel ?? '')}</td>
                <td class="cell-preview">${escapeHtml(t.lastMessage?.body ?? '')}</td>
                <td class="text-muted">${fmtTime(t.updatedAt)}</td>
                <td><span class="status-pill ${meta.cls}">${meta.label}</span></td>
              </tr>
            `;
          }).join('')}
        </tbody>
      </table>
    `;
  }

  async function openDetail(id) {
    let data;
    try {
      data = await api.adminSupport.show(id);
    } catch {
      toast('Не удалось открыть тикет', { type: 'error' });
      return;
    }
    const t = data.ticket;
    const meta = STATUS_META[t.status] ?? STATUS_META.open;
    const modal = document.createElement('div');
    modal.className = 'modal-backdrop';
    modal.innerHTML = `
      <div class="modal admin-edit-modal" style="max-width: 640px;">
        <div class="admin-edit-head">
          <div>
            <div class="goal-kicker">${escapeHtml(t.categoryLabel ?? '')}</div>
            <h2 style="margin: 4px 0 2px;">${escapeHtml(t.user.email)}</h2>
            <div class="text-muted" style="font-size: 0.82rem;">Создан ${fmtTime(t.createdAt)} · Обновлён ${fmtTime(t.updatedAt)}</div>
          </div>
          <button class="burger-close" id="close-modal" aria-label="Закрыть">✕</button>
        </div>
        <div class="thread-body" style="max-height: 320px; overflow-y: auto; margin: 14px 0;">
          ${t.messages.map((m) => `
            <div class="thread-msg thread-msg-${m.sender}">
              <div class="thread-msg-meta text-muted">${m.sender === 'admin' ? 'Ты (admin)' : 'Юзер'} · ${fmtTime(m.createdAt)}</div>
              <div class="thread-msg-body">${escapeHtml(m.body).replace(/\n/g, '<br>')}</div>
            </div>
          `).join('')}
        </div>
        <form id="reply-form">
          <div class="field">
            <textarea id="reply-input" rows="4" placeholder="Ответ юзеру" required></textarea>
          </div>
          <div class="form-error" id="reply-error"></div>
          <div class="admin-edit-actions">
            <span class="status-pill ${meta.cls}">${meta.label}</span>
            <button type="button" class="btn-ghost" id="btn-resolve" ${t.status === 'resolved' ? 'disabled' : ''}>Закрыть тикет</button>
            <button type="button" class="btn-ghost" id="btn-reopen" ${t.status !== 'resolved' ? 'disabled' : ''}>Переоткрыть</button>
            <button type="submit" id="btn-send" style="margin-left:auto;">Ответить</button>
          </div>
        </form>
      </div>
    `;
    document.body.appendChild(modal);

    const close = () => modal.remove();
    modal.querySelector('#close-modal').addEventListener('click', close);
    modal.addEventListener('click', (e) => { if (e.target === modal) close(); });

    const err = modal.querySelector('#reply-error');

    modal.querySelector('#reply-form').addEventListener('submit', async (e) => {
      e.preventDefault();
      err.textContent = '';
      const val = modal.querySelector('#reply-input').value.trim();
      if (!val) return;
      try {
        await api.adminSupport.reply(t.id, val);
        toast('Отправлено', { type: 'success' });
        close();
        await reload();
      } catch (e2) {
        err.textContent = e2.message || 'Не удалось отправить';
      }
    });

    modal.querySelector('#btn-resolve').addEventListener('click', async () => {
      try {
        await api.adminSupport.setStatus(t.id, 'resolved');
        toast('Тикет закрыт', { type: 'success' });
        close();
        await reload();
      } catch (e2) { err.textContent = e2.message; }
    });
    modal.querySelector('#btn-reopen').addEventListener('click', async () => {
      try {
        await api.adminSupport.setStatus(t.id, 'open');
        toast('Переоткрыто', { type: 'success' });
        close();
        await reload();
      } catch (e2) { err.textContent = e2.message; }
    });
  }

  await reload();
}
